let store = require("../store");
let actions = require("../actions");

let RecordingCalendar = require("../widget/RecordingCalendar");
let SubjectEquipment = require("../widget/SubjectEquipment");
let SubjectProfile = require("../widget/SubjectProfile");
let SubjectFormView = require("../view/SubjectFormView");
let SubjectData = require("../widget/SubjectData");
let SubjectProgram = require("../widget/SubjectProgram");
let SubjectConfig = require("../widget/SubjectConfig");
let TokenGenerator = require("../widget/TokenGenerator");

let IconButton = mc.widgets.IconButton;

class SubjectView extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.getInitialState();
  }

  getInitialState() {
    let { studyId, subjectId } = this.props;
    let state = store.getState();
 
    return {
      study: state.study[studyId],
      subject: state.subjects[subjectId],
      complianceStats: state.subjectComplianceStats[subjectId],
      equipment: state.equipment[subjectId],
      annotations: state.annotations[subjectId] || []
      // editing: false
    };
  }

  componentDidMount() {
    let { studyId, subjectId } = this.props;

    this.unsubscribe = store.subscribe(this.handleStoreChange.bind(this));

    actions.loadSubject(studyId, subjectId);
    actions.loadSubjectComplianceStats(studyId, subjectId);
    actions.loadEquipment(studyId, subjectId);
    actions.loadAnnotations(studyId, subjectId);

    if (!this.state.study) {
      actions.loadStudy(studyId);
    }
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  handleStoreChange() {
    this.setState(this.getInitialState());
  }

  viewMetrics() {
    mc.router.trigger("METRIC_LIST_VIEW", this.props);
  }

  editSubject() {
    this.setState({
      editing: true
    });
  }

  cancelEditing() {
    this.setState({
      editing: false
    });
  }

  onSaveSubject(subject) {
    this.setState({
      editing: false
    });
  }

  onDeleteSubject(subject) {
    mc.router.trigger("SUBJECT_LIST_VIEW", this.props);
  }

  createToken() {
    let { studyId, subjectId } = this.props;

    let opts = {
      width: "300px",
      height: "225px",
      verticalAlign: "center"
    };

    mc.ui.modal(<TokenGenerator studyId={studyId} subjectId={subjectId}/>, opts);
  }

  viewRecordings(dayStartMsUtc, recStartTs) {
    let { studyId, subjectId } = this.props;

    mc.router.trigger("RECORDING_DATA_VIEW", { studyId, subjectId, startTs: recStartTs });
  }

  render() {
    let {
      subject = {},
      study = {},
      annotations = [],
      complianceStats = [],
      equipment,
      editing
    } = this.state;

    let hasAnalytics = (study.pipelines || []).length > 0;
    let hasRemoteSensors = !!(study.deviceConfigs || []).find((cfg) => cfg.mode === "UNSUPERVISED");
    let recordings = subject.recordings || [];
    let disabled = !subject.id || !study.id || editing === true || subject.isHidden;

    return (
      <div className="rc-subject-view" data-hidden={subject.isHidden}>
        <div className="mc-split-layout">
          <h1>{subject.displayName || "..."}</h1>
          <div className="rc-subject-view-controls">
            <IconButton
              id="subject_analytics_button"
              icon="chart"
              label={tx("analytics")}
              scale={1.2}
              disabled={!hasAnalytics || recordings.length === 0}
              onPress={this.viewMetrics.bind(this)}/>
            <RecordingCalendar
              recordings={recordings}
              tz={subject.timezone}
              onSelect={this.viewRecordings.bind(this)}
              tooltip={tx("raw_data")}/>
          </div>
        </div>
        <div className="mc-sidebar-layout">
          <div>
            <div className="mc-card">
              <div className="rc-control-strip">
                <IconButton
                  id="subject_password_button"
                  icon="password"
                  label={tx("link_key")}
                  disabled={disabled || study.lifecycleState !== "IN_PROGRESS" || !hasRemoteSensors}
                  onPress={this.createToken.bind(this)}/>
                <IconButton
                  id="subject_messages_button"
                  icon="mail"
                  label={tx("link_messages")}
                  disabled={disabled || study.lifecycleState === "INITIALIZED" || !hasRemoteSensors}
                  onPress={() => mc.router.trigger("SUBJECT_MESSAGES_VIEW", this.props)}/>
                <IconButton
                  id="subject_edit_button"
                  icon="edit"
                  label={tx("edit")}
                  disabled={disabled || study.lifecycleState === "COMPLETE"}
                  onPress={this.editSubject.bind(this)}/>
              </div>
              {editing ? (
                <SubjectFormView
                  subject={subject}
                  studyId={subject.studyId}
                  onSave={this.onSaveSubject.bind(this)}
                  onCancel={this.cancelEditing.bind(this)}
                  onDelete={this.onDeleteSubject.bind(this)}/>
                ) : (
                  <SubjectProfile
                    subject={subject}
                    fields={study.subjectMetadataFields || []}/>
                )}
            </div>
            <h2>{tx("data")}</h2>
            <div className="mc-card">
              <SubjectData
                subject={subject}
                annotations={annotations}
                activities={study.activities || []}/>
            </div>
          </div>
          <div>
            <section>
              <h2>{tx("program")}</h2>
              <div className="rc-subject-view-program">
                {subject.id && study.id ? (
                  <SubjectProgram
                    program={study.program}
                    programStartTs={subject.programStartTs}
                    complianceStats={complianceStats}
                    tz={subject.timezone}/>
                ) : "..."}
              </div>
            </section>
            <section>
              <h2>{tx("remote_config")}</h2>
              <SubjectConfig study={study} devices={subject.devices}/>
            </section>
            <section>
              <h2>{tx("remote_equipment")}</h2>
              <SubjectEquipment equipment={equipment}/>
            </section>
          </div>
        </div>
      </div>
    );
  }
}

module.exports = SubjectView;